import React from "react"
import Button from 'react-bootstrap/Button'
import PropTypes from 'prop-types'

import { MakeOsLocaleInfoLongDateTime, IsEmptyString } from "./GeneralFunctions"
import { Translate } from "./Translator"

const CallNotification = (props) => {
    
    const CallfieldScripts = [...props.Call.CallfieldScripts]
    const CallfieldScriptRows = []     
    while (CallfieldScripts.length) {
        CallfieldScriptRows.push(CallfieldScripts.splice(0, 2));
    }

    const ShowRecognition = ((props.Call.Recognitions ?? []).length > 0)

    const PerformScreenpop = (aScreenpopUrl) => {
        window.open(aScreenpopUrl)
    }

    const LastEventTime = new Date(props.Call.StartTime);

    //<React.Fragment> is functionally the same as <>, but <> does not support keys
    const PaintScriptTable = (aScriptRows) => {
        return <table cellPadding="0" width="100%">
            <tbody>
                {aScriptRows.map((row,rindex) => (
                    <React.Fragment key={rindex}>
                    <tr>
                        {row.map((script,cindex) => (
                            script.ScreenpopUrl.toLowerCase().startsWith("screenpop:") ?
                            <React.Fragment key={cindex}>{cindex === 1 ? <td width="10"/> : <></>}<td width="*"><Button className="scriptbuttondisabled" title={script.Name} style={{ width: "100%"}}>{script.Name}</Button></td></React.Fragment> :
                            <React.Fragment key={cindex}>{cindex === 1 ? <td width="10"/> : <></>}<td width="*"><Button className={props.Brand === "xelion" ? "brandbuttonxelion" : (props.Brand === "enreach" || props.Brand === "summa" ? "brandbutton" : "scriptbutton")} onClick={() => PerformScreenpop(script.ScreenpopUrl)} variant="primary" title={script.Name} style={{ width: "100%"}}>{script.Name}</Button></td></React.Fragment>
                        ))}
                    </tr>
                    {rindex < aScriptRows.length - 1 ? <tr height="10"/> : <></>}
                    </React.Fragment>
                ))}
            </tbody>
        </table>
    }

    if (ShowRecognition)
    {

        let LookupResultIndex = props.LookupResultIndex
        if ((props.Call.Recognitions == null) || (props.Call.Recognitions[LookupResultIndex] == null))
        {
            LookupResultIndex = 0
        }

        let Scripts = []   
        if ((props.Call.Recognitions != null) && (props.Call.Recognitions[LookupResultIndex] != null))
        {
            props.Call.Recognitions[LookupResultIndex].Scripts.forEach((script) => { script.CallfieldScript = false; Scripts.push(script); })
        }
        if (props.Call.CallfieldScripts != null)
        {
            props.Call.CallfieldScripts.forEach((script) => { script.CallfieldScript = true; Scripts.push(script); })
        }

        const ScriptRows = []  
        while (Scripts.length) { ScriptRows.push(Scripts.splice(0, 2)); }

        if (props.Call.Direction.toLowerCase() !== "inbound")
        {
            props.Call.Recognitions[LookupResultIndex].Notification[0] = props.Call.Recognitions[LookupResultIndex].Notification[0].replaceAll("Incoming call", "Outgoing call").replaceAll("Inkomend gesprek", "Uitgaand gesprek")
        }

        if (props.Call.Recognitions.length > 1)
        {
            const PreviousIndex = LookupResultIndex > 0 ? LookupResultIndex - 1 : (props.Call.Recognitions.length - 1)
            const NextIndex = LookupResultIndex < (props.Call.Recognitions.length - 1) ? LookupResultIndex + 1 : 0

            return (
                <table width="100%">
                    <tbody>
                        <tr height="10">
                            <td colSpan="3" style={{ align: "right", fontSize: "14px", color: "#888888", marginTop: "-6px"}} align="right"><b>{(LookupResultIndex+1) + "/" + props.Call.Recognitions.length}</b></td>
                        </tr>
                        <tr>
                            <td width="25" style={{ valign: "middle", align: "left", textAlign: "left", fontSize: "20px"}}><span style={{ cursor: "pointer", align: "left", textAlign: "left"}} title={"Show previous recognized contact (" + (PreviousIndex+1) + "/" + props.Call.Recognitions.length + ")"} onClick={() => props.OnSetLookupResultIndex(PreviousIndex)}>&lt;</span></td>
                            <td>                   
                                 <b>{props.Call.Recognitions[LookupResultIndex].Notification[0]}</b><br/>
                                {props.Call.Recognitions[LookupResultIndex].Notification.filter((line,index) => index > 0).map((line,index) => <div key={index}>{line}</div>)}
                                {PaintScriptTable(ScriptRows)}
                            </td>
                            <td width="25" style={{ valign: "middle", align: "right", textAlign: "right", fontSize: "20px"}}><span style={{ cursor: "pointer", align: "right", textAlign: "right"}} title={"Show next recognized contact (" + (NextIndex+1) + "/" + props.Call.Recognitions.length + ")"} onClick={() => props.OnSetLookupResultIndex(NextIndex)}>&gt;</span></td>
                        </tr>
                        <tr>
                            <td colSpan="3" align="right" style={{ align: "right", fontSize: "12px", color: "#888888" }}><b>{LastEventTime.toLocaleString()}</b></td>
                        </tr>
                    </tbody>
                </table>
            )
        }
        else
        {      
            return (
                <span> 
                    <b>{props.Call.Recognitions[LookupResultIndex].Notification[0]}</b><br/>
                    {props.Call.Recognitions[LookupResultIndex].Notification.filter((line,index) => index > 0).map((line,index) => <div key={index}>{line}</div>)}
                    {PaintScriptTable(ScriptRows)}
                    <div align="right" style={{ align: "right", fontSize: "12px", color: "#888888" }}><b>{LastEventTime.toLocaleString()}</b></div>
                </span>
            )
        }
    }
    else
    {
        const CallfieldScripts = [...props.Call.CallfieldScripts]
        CallfieldScripts.forEach((script) => script.CallfieldScript = true)

        const ScriptRows = [] 
        const Scripts = [...CallfieldScripts]   
        while (Scripts.length) { ScriptRows.push(Scripts.splice(0, 2)); }

        return (
            props.Call.Direction.toLowerCase() === "inbound" ?
                <span> 
                    <b>{Translate("Incoming call")}</b><br/>
                    <div>{Translate("Number")}: {props.Call.CallerNumber}</div>
                    {props.Call.DeviceNumber ? <div>{Translate("Device")}: {props.Call.DeviceNumber}</div> : <span/>}  
                    <div>{Translate("Time")}: {MakeOsLocaleInfoLongDateTime(new Date(props.Call.StartTime))}</div>  
                    {PaintScriptTable(ScriptRows)}               
                </span> :
                <span> 
                    <b>{Translate("Outgoing call")}</b><br/>
                    <div>{Translate("Number")}: {props.Call.CalledNumber}</div>
                    {props.Call.DeviceNumber ? <div>{Translate("Device")}: {props.Call.DeviceNumber}</div> : <span/>}  
                    <div>{Translate("Time")}: {MakeOsLocaleInfoLongDateTime(new Date(props.Call.StartTime))}</div>  
                    {PaintScriptTable(ScriptRows)}               
                </span>
        )
    }
}

CallNotification.propTypes = {
    Brand: PropTypes.string,
    Call: PropTypes.object,
    LookupResultIndex: PropTypes.number,
    OnSetLookupResultIndex: PropTypes.func
}

export default CallNotification;